import { Api as _Api } from '../../common/api/Api';
import { locatePath } from '../../common/RelativeUrl';
export { initCsrfConfig } from '../../common/api/Api';
const baseHost = process.env.REST_API_BASE_URL || `${location.protocol}//${location.host}`;
const Base = new _Api(baseHost + locatePath('/api/v1'), '');
const Lessons = Base.appendPath('/lessons');
const CurrentUser = Base.appendPath('/users/current');
const Coaches = Base.appendPath('/coaches');
const Faqs = Base.appendPath('/faqs_with_categories');
const PastLessons = Lessons.addParams({
  past: true,
});
const RecommendedLessons = Base.appendPath('/recommended_lessons');
const LessonReserve = Lessons.appendPath(':lessonId/reserve');
const Memberships = Base.appendPath('/memberships');
const MembershipCurrent = Memberships.appendPath('current');
const MembershipTickets = Memberships.appendPath('current/tickets');
const MembershipCurrentCard = Memberships.appendPath('current/card');
const Reservations = Base.appendPath('/reservations');
const Reservation = Reservations.appendPath(':reservationId');
const SignIn = Base.appendPath('/users/sign_in');
const SignUp = Base.appendPath('/users/new');
export const Api = {
  CurrentUser,
  Coaches,
  Faqs,
  PastLessons,
  RecommendedLessons,
  LessonReserve,
  SignIn,
  SignUp,
  Memberships,
  MembershipCurrent,
  MembershipTickets,
  MembershipCurrentCard,
  Reservations,
  Reservation,
};
